<template>
  <AhaInfoBox>{{ getStatusShowCorrectOption() }}</AhaInfoBox>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
    }),
  },
  methods: {
    getStatusShowCorrectOption() {
      const single =
        'Click the box next to an option to mark it as the correct answer.'
      const multiple =
        'Please note that the audience can only pick one option. You can allow them to pick more using the settings below.'
      let count = 0
      if (!this.slideActive.SlideOptions) return single
      this.slideActive.SlideOptions.forEach((item) => {
        if (item.correct) {
          count++
        }
      })

      if (count > 1 && !this.slideActive.multipleChoice) {
        return multiple
      }
      this.moreInfo = true
      return single
    },
  },
}
</script>
